/**
 * @generated SignedSource<<c29360acbfee8785b0fd9aef51381c73>>
 * @relayHash 1a883375b2a6a14337dc51105c07f050
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 30d7d5e1ae9ef6998d6c80f39437903f638fc5d6d55dc38c4d3b20fb20d6acbe

import type { ConcreteRequest } from 'relay-runtime';
export type WatchSettingsCheckboxItemsWatchDialogUnwatchContentMutation$variables = {
  id: string;
};
export type WatchSettingsCheckboxItemsWatchDialogUnwatchContentMutation$data = {
  readonly unwatchContent: {
    readonly content: {
      readonly currentUserIsWatching: boolean;
      readonly id: string | null | undefined;
    };
  } | null | undefined;
};
export type WatchSettingsCheckboxItemsWatchDialogUnwatchContentMutation = {
  response: WatchSettingsCheckboxItemsWatchDialogUnwatchContentMutation$data;
  variables: WatchSettingsCheckboxItemsWatchDialogUnwatchContentMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "args": [
      {
        "fields": [
          {
            "kind": "Variable",
            "name": "contentId",
            "variableName": "id"
          },
          {
            "kind": "Literal",
            "name": "currentUser",
            "value": true
          }
        ],
        "kind": "ObjectValue",
        "name": "watchContentInput"
      }
    ],
    "concreteType": "WatchContentPayload",
    "kind": "LinkedField",
    "name": "unwatchContent",
    "plural": false,
    "selections": [
      {
        "concreteType": "Content",
        "kind": "LinkedField",
        "name": "content",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "id"
          },
          {
            "kind": "ScalarField",
            "name": "currentUserIsWatching"
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "WatchSettingsCheckboxItemsWatchDialogUnwatchContentMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "WatchSettingsCheckboxItemsWatchDialogUnwatchContentMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "1a883375b2a6a14337dc51105c07f050",
    "id": "30d7d5e1ae9ef6998d6c80f39437903f638fc5d6d55dc38c4d3b20fb20d6acbe",
    "metadata": {},
    "name": "WatchSettingsCheckboxItemsWatchDialogUnwatchContentMutation",
    "operationKind": "mutation",
    "text": "mutation WatchSettingsCheckboxItemsWatchDialogUnwatchContentMutation($id:ID!){unwatchContent(watchContentInput:{contentId:$id,currentUser:true}){content{id,currentUserIsWatching}}}"
  }
};
})();

(node as any).hash = "9f4a882f6a9a2ad388c10ff7750841a5";

export default node;
